import GenericDialog from './GenericDialog';

export default GenericDialog;
